import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UIModule, UIRangeComponent } from '@bannerflow/ui';
import { GenAIService } from '../../state/gen-ai.service';

@Component({
    imports: [UIModule, UIRangeComponent],
    selector: 'erase-options',
    templateUrl: './erase-options.component.html',
    styleUrls: ['./erase-options.component.scss']
})
export class EraseOptionsComponent {
    private genAiService = inject(GenAIService);

    brushSizeSignal = toSignal(this.genAiService.eraseBrushSize$, { initialValue: 40 });
    isRequestingErase = toSignal(this.genAiService.isRequestingErase$, { initialValue: false });
    private brushHistory = toSignal(this.genAiService.eraseBrushHistory$);
    private hasMask = computed(() => !!this.brushHistory()?.length);
    actionsDisabled = computed(() => this.isRequestingErase() || !this.hasMask());

    setEraseBrushSize(brushSize: number): void {
        this.genAiService.setEraseBrushSize(brushSize);
    }

    erase(): void {
        this.genAiService.erase();
    }
}
